/*global unescape: true */
'use strict';

angular.module('openDataApp')
  .factory('ApiService', ['$http', 'AuthService', function ($http, AuthService) {

    var urlBase = '/api';
    if (window.location.href.indexOf("opendata.nu")>0) {
      urlBase = 'https://api.opendata.nu/api';
    }
    var apiService = {};

    apiService.checkEmail = function (email) {
      return $http.get(urlBase + '/users/email/' + email);
    };

    apiService.getPlans = function () {
      return $http.get(urlBase + '/plans');
    };

    apiService.getCompany = function (nr) {
      return $http.get(urlBase + '/openkvkfree/minimal?kvk=' + nr);
    };

    apiService.getAddress = function (postal, nr) {
      return $http.get(urlBase + '/openadresfree?postcode=' + postal.replace(/\s/g, '') + '&huisnummer=' + nr);
    };

    apiService.newAccount = function (formData, hasPaidPlan) {
      if (!hasPaidPlan) {
        formData.plan = undefined;
      }

      return $http({
        url: urlBase + '/users',
        method: 'POST',
        data: formData
      });
    };

    apiService.updateAccount = function (formData) {
      var data = JSON.parse(JSON.stringify(formData));
      data.newPassword = undefined;
      data.oldPassword = undefined;

      data.ipadres = "";
      angular.forEach(formData.ipadres, function (value) {
        data.ipadres += ',' + value.text;
      });
      data.ipadres = data.ipadres.substring(1);

      return $http({
        url: urlBase + '/users',
        method: 'PUT',
        data: data,
        headers: {
          'X-Token': AuthService.getToken()
        }
      });
    };

    apiService.updatePassword = function (formData) {
      return $http({
        url: urlBase + '/users/password',
        method: 'PUT',
        data: {
          updated: formData.newPassword,
          old: formData.oldPassword
        },
        headers: {
          Authorization: 'Basic ' + window.btoa(unescape(encodeURIComponent(formData.email + ':' + formData.oldPassword)))
        }
      });
    };

    apiService.requestPasswordReset = function (formData) {
      return $http({
        url: urlBase + '/users/passwordreset/' + formData.email,
        method: 'GET'
      });
    };

    apiService.passwordReset = function (formData, token) {
      return $http({
        url: urlBase + '/users/passwordreset',
        method: 'PUT',
        data: formData,
        headers: {
          'X-Token': token
        }
      });
    };

    apiService.login = function (formData) {
      return $http({
        method: 'GET',
        url: urlBase + '/users/login',
        headers: {
          Authorization: 'Basic ' + window.btoa(unescape(encodeURIComponent(formData.email + ':' + formData.password)))
        }
      });
    };

    apiService.getAccountOverview = function () {
      return $http({
        method: 'GET',
        url: urlBase + '/users/overview',
        headers: {
          'X-Token': AuthService.getToken()
        }
      });
    };

    apiService.getPaymentStatus = function (token) {
      return $http({
        method: 'GET',
        url: urlBase + '/payments/' + token
      });
    };

    apiService.checkout = function (order, startDate) {
      return $http({
        method: 'POST',
        url: urlBase + '/payments' + (startDate !== undefined ? '?startMonth=' + (startDate.get('month') + 1) + '&startYear=' + startDate.get('year') : ''),
        data: order,
        headers: {
          'X-Token': AuthService.getToken()
        }
      });
    };

    return apiService;
  }]);
